export default __webpack_public_path__ + "static/media/taraIcon.cd59e623.svg";